<template>
    <div class="quotations-page">
        <app-sub-title text="Cotizaciones" />
        <div class="quotations-page-buttons">
            <button class="btn btn-primary" v-if="userCan('create-cotizaciones')" @click="createQuotation">
                <i class="fa fa-plus"></i> Crear Cotización
            </button>
        </div>
        <app-quotations-filters @filter="onFilter" />
        
        <app-quotations-list
            :data="data"
            :on-change-page="onChangePage"
            :on-edit="onEdit"
            :on-view="onView"
            :on-view-history="onViewHistory"
            :on-delete="onDelete"
            :on-restore="onRestore"
            @sort="onSort"
        />

        <!-- PopUp de Confirmación de Deshabilitación -->
        <app-pop-up
            id="quotation-delete-confirm"
            title="Deshabilitar Cotización"
            :on-close="closeDeleteModal"
        >
            <div slot="body">
                <p class="text-warning">
                    <i class="fa fa-info-circle"></i>
                    La cotización será deshabilitada y no aparecerá en las listas normales.
                </p>
                <p>
                    ¿Está seguro de deshabilitar la cotización
                    <strong>"{{ quotationToDelete ? quotationToDelete.title : '' }}"</strong>?
                </p>
                <p class="text-muted small mt-2">
                    <i class="fa fa-info-circle"></i>
                    La cotización puede ser reactivada posteriormente si es necesario.
                </p>
            </div>
            <div slot="buttons">
                <button class="btn btn-secondary" @click="closeDeleteModal" :disabled="deleting">
                    Cancelar
                </button>
                <button class="btn btn-warning" @click="confirmDelete" :disabled="deleting">
                    <i class="fa fa-ban"></i> Deshabilitar
                </button>
            </div>
        </app-pop-up>
    </div>
</template>
<script>
import quotationsRepository from '../../../repositories/quotations.repository';
import SubTitle from '../../UI/Layout/SubTitle.vue';
import QuotationsList from './QuotationsList/QuotationsList.vue';
import QuotationsFilters from './QuotationsFilters/QuotationsFilters.vue';
import PopUp from '../../UI/Controls/PopUp/PopUp.vue';
import { mixin } from '../../../mixin';

export default {
    mixins: [mixin],
    components: {
        appSubTitle: SubTitle,
        appQuotationsList: QuotationsList,
        appQuotationsFilters: QuotationsFilters,
        appPopUp: PopUp
    },
    data() {
        return {
            data: {
                data: [],
                current_page: 1,
                last_page: 1,
                from: 0,
                to: 0,
                total: 0,
                per_page: 15
            },
            page: 1,
            filters: {},
            sortBy: 'created_at',
            sortDir: 'desc',
            quotationToDelete: null,
            deleting: false
        };
    },
    created() {
        this.loadQuotations();
    },
    methods: {
        loadQuotations() {
            const pr = { ...quotationsRepository };
            pr.getPaged(this.page, {
                ...this.filters,
                sortBy: this.sortBy,
                sortDir: this.sortDir
            })
                .then(response => {
                    if (response && response.data) {
                        this.data = response;
                    } else {
                        this.data = {
                            data: [],
                            current_page: 1,
                            last_page: 1,
                            from: 0,
                            to: 0,
                            total: 0,
                            per_page: 15
                        };
                    }
                })
                .catch(error => {
                    toastr.error('Error al cargar las cotizaciones');
                    console.error(error);
                });
        },
        onChangePage(page) {
            this.page = page;
            this.loadQuotations();
        },
        onSort({ sortBy, sortDir }) {
            this.sortBy = sortBy;
            this.sortDir = sortDir;
            this.page = 1;
            this.loadQuotations();
        },
        onFilter(filters) {
            this.filters = filters || {};
            this.page = 1;
            this.loadQuotations();
        },
        createQuotation() {
            this.$router.push({ name: 'quotationCreatePage' });
        },
        onEdit(quotation) {
            this.$router.push({ name: 'quotationEditPage', params: { id: quotation.id } });
        },
        onView(quotation) {
            this.$router.push({ name: 'quotationViewPage', params: { id: quotation.id } });
        },
        onViewHistory(quotation) {
            this.$router.push({ name: 'quotationHistoryPage', params: { id: quotation.id } });
        },
        onDelete(quotation) {
            this.quotationToDelete = quotation;
            this.$bus.$emit('quotation-delete-confirm.open');
        },
        onRestore(quotation) {
            if (!quotation || !quotation.id) return;

            if (!confirm(`¿Está seguro de reactivar la cotización "${quotation.title}"?`)) {
                return;
            }

            const pr = { ...quotationsRepository };
            pr.restoreQuotation(quotation.id)
                .then(response => {
                    if (response && response.status) {
                        toastr.success(response.msg || 'Cotización reactivada exitosamente');
                        this.loadQuotations();
                    } else {
                        toastr.error(response?.msg || 'Error al reactivar la cotización');
                    }
                })
                .catch(error => {
                    toastr.error('Error al reactivar la cotización');
                    console.error(error);
                });
        },
        closeDeleteModal() {
            this.quotationToDelete = null;
        },
        confirmDelete() {
            if (!this.quotationToDelete) return;

            this.deleting = true;
            const pr = { ...quotationsRepository };
            pr.deleteQuotation(this.quotationToDelete.id)
                .then(response => {
                    if (response && response.status) {
                        toastr.success(response.msg || 'Cotización deshabilitada exitosamente');
                        this.$bus.$emit('quotation-delete-confirm.close');
                        this.loadQuotations();
                    } else {
                        toastr.error(response?.msg || 'Error al deshabilitar la cotización');
                    }
                })
                .catch(error => {
                    toastr.error('Error al deshabilitar la cotización');
                    console.error(error);
                })
                .finally(() => {
                    this.deleting = false;
                });
        }
    }
};
</script>

